import { useMsal } from '@azure/msal-react';

const LogoutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutPopup({
      postLogoutRedirectUri: window.location.origin,
      mainWindowRedirectUri: window.location.origin,
    });
  };

  return (
    <button onClick={handleLogout} className="btn-ghost text-sm">
      Sign Out
    </button>
  );
};

export default LogoutButton;